export default __webpack_public_path__ + "static/media/No.5-1.e2aff39c.jpg";